import { buildService } from './decorated-service';
import {
  StaticOCRApplication,
  OptionalOCRApplication,
  OCRApplication
} from '../../../core/types/submissions/ocr-application';
import {
  handleSubmissionError,
  purgeEmptyFields,
  removeExtraAddressFields,
  submissionTimeOutErrorCode
} from './util';
import settings from '../../../settings.json';

const api = buildService(
  '/new-account-svc/service/front-office/account/one-call-rollover'
);

export const ocrSubmissionMock = {
  responseCode: null,
  submissionTime: '2021-07-07T17:54:07.546+0000',
  accounts: [
    {
      investmentVehicle: {
        trpCode: 'DMG'
      },
      accountNumber: '5722334746',
      existing: true
    },
    {
      investmentVehicle: {
        trpCode: 'BCG'
      },
      accountNumber: '114643441',
      existing: true
    },
    {
      investmentVehicle: {
        trpCode: 'MTF'
      },
      accountNumber: '112233441',
      existing: true
    }
  ],
  loginToken: null
};

export const createOCROMNIApplicationService = async (
  args: OptionalOCRApplication
): Promise<any> => {
  if (settings['mockedMode']) return ocrSubmissionMock;

  const validated: StaticOCRApplication = OCRApplication.check(args);
  const submissionPayload = purgeEmptyFields(validated);
  const finalSubmissionPayload = removeExtraAddressFields(submissionPayload);

  return api.add(finalSubmissionPayload, {
    submissionTimeOutErrorCode,
    handleServiceResponse: handleSubmissionError
  });
};
